import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

// Full Markdown renderer for blog posts (headings, links, images, tables, code).
// Distinct from `lib/markdown.tsx`, which is a deliberately tiny renderer for
// problem prompts. Posts are admin-authored, but we still run rehype-sanitize so
// a pasted `<script>`/`onerror` can never execute in a reader's browser.
const BlogMarkdown: React.FC<{ text: string }> = ({ text }) => (
  <div className="blog-markdown">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSanitize]}
      components={{
        // Open post links in a new tab. Children (the link text) are spread
        // through, so the anchor always has accessible content.
        a: ({ node, children, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
        ),
      }}
    >
      {text}
    </ReactMarkdown>
  </div>
);

export default BlogMarkdown;
